<div>
    <ng-content select="[content]"></ng-content>
</div>
